const getCountDecimalNumber = (value) => {
  if (value > -1 && value < 0) {
    return String(value).length - 3
  } else if (value > 0 && value < 1) {
    return String(value).length - 2
  } else {
    return 0
  }
}

export const fixDivide = (a, b) => {
  const countDecimalA = getCountDecimalNumber(a)
  const countDecimalB = getCountDecimalNumber(b)

  if (countDecimalA > countDecimalB) {
    return (
      (a * Math.pow(10, countDecimalA)) /
      (b * Math.pow(10, countDecimalB)) /
      Math.pow(10, countDecimalA - countDecimalB)
    )
  } else {
    return (
      ((a * Math.pow(10, countDecimalA)) / (b * Math.pow(10, countDecimalB))) *
      Math.pow(10, countDecimalB - countDecimalA)
    )
  }
}

export const fixMultiply = (a, b) => {
  const countDecimalA = getCountDecimalNumber(a)
  const countDecimalB = getCountDecimalNumber(b)

  return (
    (a * Math.pow(10, countDecimalA) * (b * Math.pow(10, countDecimalB))) /
    Math.pow(10, countDecimalA + countDecimalB)
  )
}

export const fixAdd = (a, b) => {
  const countDecimalA = getCountDecimalNumber(a)
  const countDecimalB = getCountDecimalNumber(b)
  const countMax = Math.max(countDecimalA, countDecimalB)

  return (
    (a * Math.pow(10, countMax) + b * Math.pow(10, countMax)) /
    Math.pow(10, countMax)
  )
}
